const TIGER_BOOT_ATLASES: [string, string, string][] = [
  ['tiger-crossed', 'Bosses/Boogatooth/BoogatoothCrossed-sheet.grid.png', 'Bosses/Boogatooth/BoogaToothCrossed.grid.json'],
  ['tiger-angry', 'Bosses/Boogatooth/BoogaToothAngry-sheet.grid.png', 'Bosses/Boogatooth/BoogaToothAngry.grid.json'],
];

export function queueBoogasLoad(scene: Phaser.Scene) {
  for (const [key, sheet, json] of TIGER_BOOT_ATLASES) {
    if (scene.textures.exists(key)) continue;
    scene.load.atlas(key, sheet, json);
  }
}
